import { compose } from 'ramda';
import { withHandlers } from 'recompose';
import { launchGame } from './actions';

export default compose(
    withHandlers({
        launchGame: ({ customLaunchGame, code, mode = 1, gameLaunchType, queryString }) => (data) => {
            let args = { code, mode, gameLaunchType, queryString };

            if (!(data instanceof Event)) {
                args = { ...args, ...data };
            }

            if (customLaunchGame) {
                customLaunchGame(args);
            } else {
                launchGame(args);
            }
        }
    })
);
